<style scoped>
    body {
        background: white;
    }
    .table {
        margin-bottom: 0 !important;
    }
    table thead th, .btn {
    background-color: #0c2c77 !important;
    color: white;  
    }
</style>
<template>
    <CContainer>
        <CCard class="border-0 shadow rounded">
        <CCardHeader class="border-0"><h4 class="font-weight-bold">Data Anggota</h4></CCardHeader>
            <CCardBody>               
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="kategori" class="font-weight-bold">Kategori</label>
                        <select name="kategori" class="form-control" id="" v-model="filterKategori">
                            <option v-for="value in dataKategori" :value="value.namaKategori" :key="value">{{value.namaKategori}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="status" class="font-weight-bold">Status</label>
                        <select name="status" class="form-control" id="" v-model="statusAnggota">
                            <option value="aktif">Aktif</option>
                            <option value="tidak_aktif">Tidak Aktif</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3">
                        <label for="nama" class="font-weight-bold">Nama</label>
                        <input type="text" class="form-control" v-model="filter" placeholder="Cari Nama">
                    </div>
                    <div class="form-group d-flex align-items-end col-md-2">
                        <button class="btn btn-md btn-primary px-4 mx-auto" @click="terapkanFilter"><font-awesome-icon icon="search" class="mr-2" /> Cari</button>
                    </div>
                </div>                
            </CCardBody>
        </CCard>

        <div class="mt-5" ref="tableDataAnggota">
            
            <h4 class="font-weight-bold mb-3">Data Anggota Akuntan Publik</h4>
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>No. Anggota</th>
                        <th>Nama Anggota</th>
                        <th>No. Izin AP</th>
                        <th>Nama Kantor</th>
                        <th class="text-center">Status Anggota</th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="(value, index) in items" :key="index">
                        <td >{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
                        <td>{{value.no_anggota ? value.no_anggota : '-'}}</td>
                        <td>{{value.nama_lengkap ? value.nama_lengkap : '-'}}</td>
                        <td>{{value.no_izin_ap ? value.no_izin_ap : '-'}}</td>
                        <td>{{value.nama_kap ? value.nama_kap : '-'}}</td>
                        <td class="text-center font-weight-bold text-success" v-if="value.status_keanggotaan == 1 || value.status_keanggotaan == 'active'">Aktif</td>
                        <td class="text-center font-weight-bold text-danger" v-else>Tidak Aktif</td>
                    </tr>
                    <tr>
                        <td colspan="6" class="text-center font-weight-bold" v-if="items == [] || items == ''">Data Tidak Tersedia</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="bg-white row mt-2">
            <div class="col-md-12">
                <CPagination
                    style="float:right"
                    :active-page.sync="currentPage"
                    :pages="pagination.totalPages"
                    responsive
                    @click="pageChange"
                />
            </div>
        </div>
    </CContainer>
</template>
<script>
import DataAnggotaService from '@/services/web-view/data-anggota.service'

export default {
    data() {
        return {
            items: [],
            dataKategori: [],
            statusAnggota: 'aktif',
            filter: '',
            filterKategori: '',
            modelKategori: '',
            currentPage: 0,
            indexed: 0,
            pagination: {
                totalPages: 0
            },
            tipe_halaman : 'default',
        }
    },
    mounted() {
        this.getDataKategoriAnggota('0', '10', 'default');
        this.tipe_halaman = "all_data";
    },

    watch: {
        currentPage: function(val) {
        var page = val - 1;
        this.indexed = page * 10;
        this.getData(val - 1, this.pageSize, this.filter, this.filterKategori, this.statusAnggota);
        }
    },

    methods: {
        getData(currentPage, pageSize, filter, filterKategori, statusAnggota) {
            var vm = this
            if(filterKategori == "Semua Kategori") {
                filterKategori = "default"
            }
            // let loader = this.$loading.show({
            //     container: this.$refs.tableDataAnggota,
            //     canCancel: false,
            //     onCancel: this.onCancel,
            // });
            DataAnggotaService.getDataAnggota(
                currentPage,
                pageSize,
                filter,
                filterKategori,
                statusAnggota
            )
            .then((response) => {
                vm.items = response.data.data.content;
                vm.pagination.totalPages = response.data.data.totalPages;
                vm.currentPage = response.data.data.pageable.pageNumber + 1;
                // comment console console.log(response.data.data.content)
                // loader.hide()
            })
            .catch((error) => {
                // comment console console.log(error);
                // loader.hide()
            });
        },

        getDataKategoriAnggota(currentPage, pageSize, filter) {
            var vm = this
            DataAnggotaService.getKategoriAnggota(
                currentPage,
                pageSize,
                filter
            )
            .then((response) => {

            vm.dataKategori = response.data.data.content;
            vm.pagination.totalPages = response.data.data.totalPages;
            vm.currentPage = response.data.data.pageable.pageNumber + 1;

            if(this.tipe_halaman == "all_data") {
                var data = {
                    namaKategori : "Semua Kategori",
                    idKategoriAnggota : "default"
                }
                
                this.dataKategori.unshift(data);
            }

            vm.filterKategori = vm.dataKategori[0].namaKategori;
            })
            .catch((error) => {
                // comment console console.log(error);
            });
        },

        selectKategori(value) {
            this.filterKategori = value.idKategoriAnggota
        },

        changeKategori(value) {
        },

        terapkanFilter() {
            this.getData('0', '10', this.filter, this.filterKategori, this.statusAnggota)
        }
    }
}   
</script>